// contexts/OtpContext.tsx
import React, { createContext, ReactNode, useContext, useState } from 'react';
import { OtpChannel, OtpFlow } from '../_types/otp.types';
import { OtpChannelEnum } from '../constantes/OtpChannelEnum';
import { FlowType } from '../constantes/FlowTypeEnum';

interface OtpContextData {
  currentFlow: OtpFlow;
  setCurrentFlow: (flow: OtpFlow) => void;
  setSelectedChannel: (channel: OtpChannel) => void;
  selectedChannel: OtpChannel;
  clearDestinationInfo: () => void;
  otpId: string | null;
  setOtpId: (id: string | null) => void;
  otpCode: string | null;
  setOtpCode:  (code: string | null) => void;
  
}

const OtpContext = createContext<OtpContextData>({} as OtpContextData);

interface OtpProviderProps {
  children: ReactNode;
}

export const OtpProvider: React.FC<OtpProviderProps> = ({ children }) => {
  const [currentFlow, setCurrentFlow] = useState<OtpFlow>(FlowType.AUTHENTICATION);
  const [selectedChannel, setSelectedChannel] = useState<OtpChannel>(OtpChannelEnum.EMAIL);
  const [otpId, setOtpId] = useState<string | null>(null);
  const [otpCode, setOtpCode] = useState<string | null>(null);
  
  const clearDestinationInfo = () => {
    setCurrentFlow(FlowType.AUTHENTICATION);
    setSelectedChannel(OtpChannelEnum.EMAIL);
  };
  
  return (
    <OtpContext.Provider
      value={{
        currentFlow,
        setCurrentFlow,
        selectedChannel,
        setSelectedChannel,
        clearDestinationInfo,
        otpId,
        setOtpId,
        otpCode,
        setOtpCode
      }}
    >
      {children}
    </OtpContext.Provider>
  );
};

export const useOtpContext = () => {
  const context = useContext(OtpContext);
  
  if (!context) {
    throw new Error('useOtpContext deve ser usado dentro de um OtpProvider');
  }
  
  return context;
};
